import { AxiosError } from 'axios';
import { getProducts } from '../service/fetchProducts';
import showToast from '../components/ToastComponent';
import { Product } from '../interface/interface';
import { useState } from 'react';

const useToFetchAllProducts = (): [
  (accessToken: string | undefined) => Promise<any>,
  boolean,
] => {
  const [loading, setLoading] = useState<boolean>(false);

  const fetchAllProducts = async (accessToken: string | undefined) => {
    if (!accessToken) return;

    try {
      setLoading(true);
      const productResponse = await getProducts(accessToken);
      if (typeof productResponse === 'number') {
        setLoading(false);
        showToast({
          type: 'warning',
          message: 'Error while fetch Products',
        });
      } else {
        setLoading(false);
        return productResponse.map((product: Product) => ({
          label: product.name,
          value: product.id,
        }));
      }
    } catch (e) {
      const error = e as AxiosError;
      return (error as AxiosError).response?.status;
    }
  };

  return [fetchAllProducts, loading];
};

export default useToFetchAllProducts;
